const jhsnotaspringWidgetData = [
  {
    songTitle: "Spring Time",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_notaspring_spring_time_on.mp3?v=1743985358",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_notaspring_spring_time_off.mp3?v=1743985358",
    video: "https://cdn.shopify.com/videos/c/o/v/7df19207fff6475282fa265b36df2d57.mp4"
  },
  {
    songTitle: "RnB Lead",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_notaspring_rnb_lead_on.mp3?v=1743985358",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_notaspring_rnb_lead_off.mp3?v=1743985358",
    video: "https://cdn.shopify.com/videos/c/o/v/f9def75cec274dc49a8e7568eb4a0492.mp4"
  },
  {
    songTitle: "Synth Size",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_notaspring_synth_size_on.mp3?v=1743985358",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_notaspring_synth_size_off.mp3?v=1743985358",
    video: "https://cdn.shopify.com/videos/c/o/v/79808e38f8b9402b88532cc43178209a.mp4"
  },
  {
    songTitle: "Drum Space",
    on: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_notaspring_drum_space_on.mp3?v=1743985358",
    off: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_notaspring_drum_space_off.mp3?v=1743985358",
    video: "https://cdn.shopify.com/videos/c/o/v/046c4413b36d4798a07270f83483fa8f.mp4"
  }
];
